import React from 'react'
import type { AdminRole } from '../../types'
import { tx } from '../../lib/i18n'

interface RoleBadgeProps {
  /** built-in role or a custom role name */
  role: AdminRole | (string & {})
  /** display name for custom roles (built-in roles have their own) */
  label?: string | null
  size?: 'sm' | 'md'
}

const roleConfig: Record<string, { label: string; color: string }> = {
  super_admin: { label: tx('Super Admin'), color: 'bg-rose-100 text-rose-800 border-rose-200' },
  support: { label: tx('Support'), color: 'bg-blue-100 text-blue-800 border-blue-200' },
  finance: { label: tx('Finance'), color: 'bg-green-100 text-green-800 border-green-200' },
  product_ops: { label: 'Product Ops', color: 'bg-purple-100 text-purple-800 border-purple-200' },
}

const RoleBadge: React.FC<RoleBadgeProps> = ({ role, label, size = 'md' }) => {
  const config = roleConfig[role] || { label: label || role, color: 'bg-amber-50 text-amber-800 border-amber-200' }
  const sizeClass = size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-xs font-medium'

  return (
    <span className={`inline-flex items-center rounded-full border font-medium ${config.color} ${sizeClass}`}>
      {config.label}
    </span>
  )
}

export default RoleBadge
